// SPDX-License-Identifier: GPL-3.0-only
// Copyright (C) 2026 Kyle Johnson
// This file is part of Hushold.
//
// Hushold is free software: you can redistribute it and/or modify
// it under the terms of the GNU General Public License as
// published by the Free Software Foundation, version 3.

import { Haptics, ImpactStyle, NotificationType } from '@capacitor/haptics';
import { IS_NATIVE } from './platform.js';

// DECISION: Haptics are reserved for moments where a physical confirmation adds
// real value — saving a transaction, toggling a reconcile state, completing a
// reconciliation. They are deliberately NOT fired on every tap (that would feel
// noisy and un-Hushold). Every call is a no-op on web and swallows errors so a
// missing taptic engine never breaks a flow.

export async function hapticSuccess(): Promise<void> {
  if (!IS_NATIVE) return;
  try {
    await Haptics.notification({ type: NotificationType.Success });
  } catch {
    /* no haptics hardware */
  }
}

export async function hapticLight(): Promise<void> {
  if (!IS_NATIVE) return;
  try {
    await Haptics.impact({ style: ImpactStyle.Light });
  } catch {
    /* no haptics hardware */
  }
}

export async function hapticMedium(): Promise<void> {
  if (!IS_NATIVE) return;
  try {
    await Haptics.impact({ style: ImpactStyle.Medium });
  } catch {
    /* no haptics hardware */
  }
}

export async function hapticWarning(): Promise<void> {
  if (!IS_NATIVE) return;
  try {
    await Haptics.notification({ type: NotificationType.Warning });
  } catch {
    /* no haptics hardware */
  }
}
